<div  class="header" appBg="primary" brightness="darker">
  <a *ngIf="showMenu" (click)="sidenav.toggle()" appIconColor><span class="material-icons">menu</span></a>
  <a *ngIf="!showMenu" routerLink="/dashboard" appIconColor><i class="fas fa-arrow-left"></i></a>
  <h5 class="my-2" appTextColor="secondary">{{ Localization.JobsApp | translate }}</h5>
</div>

<mdb-side-nav #sidenav class="white" [fixed]="false">
  <li appBg class="nav top">
    <div class="logo">
      <a appTextColor>{{ getUserInitials() }}</a>
    </div>
    <div appTextColor class="user-info">
      <span>{{getUsername()}}</span>
    </div>
  </li>
  <li class="nav">
    <ul>
      <li>
        <a routerLink="/dashboard" (click)="sidenav.hide()">
          <span>{{Localization.Home | translate}}</span>
        </a>
      </li>
      <!--<li>
        <a routerLink="/documents" (click)="sidenav.hide()">
          <span>{{Localization.Contact | translate}}</span>
        </a>
      </li>-->
    </ul>
  </li>
  <li class="nav bottom">
    <ul>
      <!--<li>
        <a routerLink="/account" (click)="sidenav.hide()">
          <span>{{Localization.MyAccount | translate}}</span>
        </a>
      </li>-->
      <li>
        <a (click)="logout()">
          <span>{{Localization.Logout | translate}}</span>
        </a>
      </li>
    </ul>
  </li>
  <li class="button">
    <button type="button" mdbBtn mdbWavesEffect (click)="onAddIssue()">
      <i class="fas fa-plus" [class.mr-1]="true"></i>
      {{Localization.AddIssue | translate | uppercase}}
    </button>
  </li>
  <div class="sidenav-bg mask-strong"></div>
</mdb-side-nav>
